<template>
  <b-modal
    ref="modal"
    title="Remove background"
    @hide="closeHandler"
    @show="reset"
  >
    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
      <ButtonPrimary
        variant="primary"
        @click="accept"
      >
        Remove background
      </ButtonPrimary>
    </template>

    <b-form-group v-if="!isLoading">
      <b-form-radio
        v-model="isReplace"
        :value="false"
      >
        Copy before removing background
      </b-form-radio>
      <b-form-radio
        v-model="isReplace"
        :value="true"
      >
        Replace image file after removing background
      </b-form-radio>
      <b-form-checkbox
        v-model="isCropToImage"
        :value="true"
        :unchecked-value="false"
      >
        Crop to image
      </b-form-checkbox>
    </b-form-group>

    <b-spinner v-else />
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from './mixin'
import {createNamespacedHelpers} from 'vuex'
import {MUTATIONS} from "../../../../store/file-browser";
import Requests from "../../../../services/api/file-browser";

const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "RemoveBackgroundModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [mixinModal],
  data: () => ({
    isReplace: false,
    isLoading: false,
    isCropToImage: true,
  }),
  computed: {
    ...mapGetters(['selectedItems'])
  },
  methods: {
    ...mapMutations([MUTATIONS.CLEAR_SELECTION]),
    ...mapActions(['fetchList']),
    async accept() {
      const maxFileSizeInBytes = 22 * 1024 * 1024;

      this.isLoading = true;

      let successCount = 0;
      let failCount = 0;
      let hasTooLarge = false;

      for (const item of this.selectedItems) {
        let file;

        try {
          file = await this.fetchFile(item);

          const formData = new FormData();

          formData.append("file", file);
          formData.append("is_replace", this.isReplace ? 1 : 0);
          formData.append("crop_to_image", this.isCropToImage ? 1 : 0);
          formData.append("path", (item.full_url ?? item.path).split('?file=')[1]);

          await Requests.saveRemoveBGImage(formData);

          successCount++;
        } catch (error) {
          failCount++;

          if (file && file.size > maxFileSizeInBytes) {
            hasTooLarge = true;
          }
        }
      }

      this.fetchList();

      if (failCount === 0) {
        toastr.success(successCount > 1 ? `Removed background from ${successCount} files!` : 'Removed File Background!');
      } else if (successCount === 0) {
        toastr.error(hasTooLarge ? 'Request entity too large' : 'Remove background failed');
      } else {
        toastr.warning(`Removed background from ${successCount} file(s), ${failCount} failed`);
      }

      this.close();
      this[MUTATIONS.CLEAR_SELECTION]();
    },
    reset() {
      this.isReplace = false;
      this.isLoading = false;
      this.isCropToImage = true;
    },
    async fetchFile(item) {
      const response = await fetch(item.full_url ?? item.path);
      const contentType = response.headers.get("content-type");
      const blob = await response.blob();

      return new File([blob], "remove_bg_image.jpg", { contentType });
    }
  }
}
</script>

<style scoped lang="scss">

</style>
